import React, { useEffect, useState } from 'react'
import { useTranslate } from '../components/TranslationText'
import axios from "../axios/axios";
import { useLocation, useNavigate } from 'react-router';
import ImagesSlider from '../components/ImagesSlider';
import CronometerCounter from '../components/CronometerCounter';
import { limit, onSnapshot, orderBy, query, Timestamp, where } from 'firebase/firestore';
import { bidsCollectionRef } from '../firebase/collections';
import { Link } from 'react-router-dom';
import { convertToCamelCase } from '../helper/convertToCamelCase';
import { formateDateToMac } from '../helper/convertDateToISO';
import { AuctionTimer } from '../components/auctions/header';
import { btnContainerShow, iconContainer, pageTitleShow, serviceRequestHeadContainer, showIconsContainer, whiteCard } from '../common/cssclasses';
import PillBtn from '../components/PillBtn';
import CustomSecondPopUp from '../components/CustomSecondPopUp';
import { enrollBidder, getauctionwithhorse } from './auctionDetails/api/auctionApis';
import CustomPopUp from '../components/CustomPopUp';
import NetaqInput from '../components/NetaqInput';
import SectionTitle from '../components/SectionTitle';

const BaseURL = process.env.REACT_APP_BASE_URL;

export default function HybridBiddingPage({ toast }) {
    const navigate = useNavigate();
    const [showPopUp, setShowPopUp] = useState(false)
    const { translate } = useTranslate();
    const location = useLocation();
    const [horseEntryTime, setHorseEntryTime] = useState(new Date());
    const searchParams = new URLSearchParams(location.search);
    const auctionId = searchParams.has("auctionID")
        ? searchParams.get("auctionID")
        : "";
    const horseID = searchParams.has("auctionHorseId")
        ? searchParams.get("auctionHorseId")
        : "";
    const [enrollButtonText, setEnrollButtonText] = useState(
        translate("web.enrollNow", "Enroll Now")
    );
    const user = localStorage.getItem('eahsUserProfile') ?? '';
    const userProfile = !!user ?
        JSON.parse(localStorage.getItem("eahsUserProfile")) : '';
    const [userProfileAuction, setUserProfileAuction] = useState({
        "Full Name": "",
        Nationality: "",
        Address: "",
        "Phone Number": "",
        "Emirates ID": "",
    });
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const [auctionDataLoaded, setAuctionDataLoaded] = useState(false);
    const [biddersDataLoaded, setBiddersDataLoaded] = useState(false);
    const [auctionData, setAuctionData] = useState({});
    const [biddersData, setBiddersData] = useState([]);
    const [horseData, setHorseData] = useState([]);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [loader, setLoader] = useState(false);
    const [isBidForOthers, setIsBidForOthers] = useState(false);
    const paymentMethod = "";
    const [multiplieAcmount, setMultiplieAcmount] = useState(2);

    async function increaseNewBid() {
        setMultiplieAcmount((prevMultiplieAmount) => prevMultiplieAmount + 1);
        setNewBid((prevNewBid) => parseInt(prevNewBid + UIincrementalIncrease ?? 0));
    }

    async function decreaseNewBid() {
        if (multiplieAcmount > 2) {
            setMultiplieAcmount((prevMultiplieAmount) => prevMultiplieAmount - 1);
            setNewBid((prevNewBid) => parseInt(prevNewBid - UIincrementalIncrease ?? 0));
        }
    }

    // bidding information
    const [isEnrolledUser, setIsEnrolledUser] = useState(false);
    const [bidderNumber, setBidderNumber] = useState(0);
    const [bidderId, setBidderId] = useState('');
    const [newBid, setNewBid] = useState(0);
    const [UIincrementalIncrease, setIncrementalIncrease] = useState(0);
    let incrementalIncrease = 0;

    // get auction data 
    async function getAuctionData(id = auctionId) {
        const hasHorse = !!horseID;
        const horseId = hasHorse ? horseID : "";
        try {
            const res = await getauctionwithhorse(id, horseId);

            setAuctionData(res);
            setIsEnrolledUser(res?.isUserEnrolled);
            setBidderNumber(res?.bidderNumber);
            setBidderId(res?.bidderId)
            const inArenaHorses = res?.horse;
            setHorseData(inArenaHorses);
            if (!!inArenaHorses?.auctionHorseId && inArenaHorses?.auctionHorseId != '00000000-0000-0000-0000-000000000000') {
                getBiddersData(id, inArenaHorses?.horseId, inArenaHorses?.incrementalIncrease, inArenaHorses?.startingPrice);
                setIncrementalIncrease(inArenaHorses?.incrementalIncrease ?? 0);
                incrementalIncrease = inArenaHorses?.incrementalIncrease ?? 0;
                setHorseEntryTime(new Date(inArenaHorses?.horseDateInArena));
            }
            setAuctionDataLoaded(true);
        } catch (error) {
            console.debug('error in getting auction data', error)
        }
    }
    // get biddres
    async function getBiddersData(auctionId, horseId, incrementalIncrease = 0, startingPrice = 0) {
        try {
            const bids = await axios.get(`/bid?auctionId=${auctionId}&horseId=${horseId}`)
            if (bids.data.status.responseCode == "200") {
                setBiddersData(bids.data.result);
                setBiddersDataLoaded(true);
                if (bids.data.result.length > 0) {
                    setNewBid(parseInt(bids.data.result[0].horseAmount ?? 0) + incrementalIncrease);
                } else {
                    setNewBid(parseInt(startingPrice ?? 0) + incrementalIncrease);

                }
            }
        } catch (error) {
            console.error('error in getting bidders Data', error);
        }
    }




    // submit new bid
    async function handleOnsubmit() {
        if (isEnrolledUser === true) {
            async function placeBid() {
                const placeBid = await axios.post("/bid", {
                    bidAmount: newBid,
                    hourseAmount: newBid,
                    bidderID: bidderId,
                    auctionID: auctionId,
                    horseId: horseData.horseId,
                    bidderName: "",
                    deviceType: 2,
                    bidderNumber: bidderNumber,
                    bidderType: "online",
                });
                if (placeBid?.data?.status?.responseCode == "200") {
                    toast.success(
                        translate("web.submissionSuccessful", "Submission Successful")
                    );
                } else {
                    toast.error(
                        translate("web.errorInPlacingBid", "Error in Placing Bid")
                    );
                }
            }
            placeBid();

        } else {
            // Show the success message
            toast.error(
                translate(
                    "web.pleaseEnrollAndMakepayment",
                    "Please Enroll And Make payment"
                )
            );
        }
    }


    // now get the Inital data on page Load
    useEffect(() => {
        getAuctionData();
    }, [])

    // firestore 
    const oneMinuteAgo = new Date();
    useEffect(() => {
        const hasHorse = !!horseID;
        const horseId = hasHorse ? horseID : "";
        const q = hasHorse ? query(
            bidsCollectionRef,
            where("AuctionId", "==", auctionId),
            where("AuctionHorseId", "==", horseId),
            orderBy('TimeStamp', 'desc'),
            where("TimeStamp", ">=", oneMinuteAgo),
            limit(1),
        ) : query(
            bidsCollectionRef,
            where("AuctionId", "==", auctionId),
            orderBy('TimeStamp', 'desc'),
            where("TimeStamp", ">=", oneMinuteAgo),
            limit(1),
        );

        // Set up a real-time listener for new documents
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const newEntries = snapshot.docs.map((doc) => {
                const data = doc.data();

                // Format date before setting it into state
                return {
                    id: doc.id,
                    ...data,
                };
            });

            if (newEntries.length > 0) {
                // add new bid to the Table on UI
                if (!!newEntries[0].BidderNumber) {
                    const formattedBidders = newEntries.map((bidder) => ({
                        bidderNumber: bidder.BidderNumber,
                        bidderName: currentLanguage == 'en' ? bidder.BidderName : bidder.BidderNameAr,
                        horseAmount: parseInt(bidder.HorseAmount),
                        bidTime: bidder.BidTime,
                        bidderType: bidder.BidderType,
                    }));
                    setBiddersData((prevDocs) => [...formattedBidders, ...prevDocs]);
                    if (formattedBidders.length > 0) {
                        setNewBid(parseInt(formattedBidders[0].horseAmount) + incrementalIncrease);
                    }
                }

                if (newEntries[0].ChangeIncrementalIncreaseAmount == 'True') {
                    setIncrementalIncrease(parseInt(newEntries[0].NewIncrementalIncreaseAmount));
                    incrementalIncrease = parseInt(newEntries[0].NewIncrementalIncreaseAmount);
                    setNewBid((prev) => prev - parseInt(newEntries[0].OldIncrementalIncreaseAmount) + parseInt(newEntries[0].NewIncrementalIncreaseAmount))
                }
                if (newEntries[0].HorseStatus == 'StartBidding') {
                    toast.warn('new Horse Added');
                    setBiddersData([]);
                    getAuctionData();

                }
                if (newEntries[0].HorseStatus == 'Sold') {
                    toast.success('Current horse is Sold');
                    setHorseData([]);
                    setBiddersData([]);
                }
                if (newEntries[0].HorseStatus == 'UnSold') {
                    toast.error('Current horse is UnSold');
                    setHorseData([]);
                    setBiddersData([]);
                }

            }

        });

        // Clean up listener on unmount
        return () => unsubscribe();
    }, []);



    const handleExternalLink = (url) => {
        window.location.href = url + `&returnUrl=${BaseURL}/hybridBidding?auctionID=${auctionId}`;
    };


    const requestRefund = async () => {
        try {
            const res = await axios.post(`/bidders/refundrequest?auctionId=${auctionId}`);
            console.debug('refunded', res);
            if (res.data.status.responseCode == "200") {
                toast.success(translate('web.requestSendSuccessfully', 'Request Send Successfully'))
                setIsEnrolledUser(false);
            } else {
                if (res.data.status.responseCode == "100") {
                    toast.error(translate(`web.${convertToCamelCase(res.data.status.detailedResponseCode)}`, res.data.status.detailedResponseCode))
                }
            }

        } catch (error) {
            toast.error('error in requesting refund Please Contact the Admin')
        }
    }


    function enrollNow() {
        enrollBidder(auctionId, userProfile?.id, isBidForOthers).then((res) => {
            if (!!res) {
                handleExternalLink(res);
            } else {
                toast.error(translate('web.errorInEnrollmentPleaseContantTheAdmin', 'Error In Enrollment Please Contant The Admin'))
            }

        })
    }

    return (
        <React.Fragment>


            {!!auctionDataLoaded && (
                <React.Fragment>

                    <>
                        <div className={serviceRequestHeadContainer}>
                            <h2 className={pageTitleShow}>
                                {auctionData?.name}
                            </h2>
                            <div className={btnContainerShow}>
                                {isEnrolledUser &&
                                    <PillBtn
                                        isSubmitBtn
                                        isWithClass
                                        isNoMargin
                                        classes="btn-secondary mb-2"
                                        isNoAction={true}
                                        onClick={requestRefund}
                                        text={translate('web.requestRefund', 'Request Refund')}
                                    />
                                }
                                {isEnrolledUser == false && auctionData?.isEnrollOpened &&
                                    <CustomSecondPopUp
                                        trigger={<PillBtn
                                            isSubmitBtn
                                            isWithClass
                                            isNoMargin
                                            classes="btn-secondary mb-2"
                                            isNoAction={true}
                                            text={enrollButtonText}
                                        />}
                                        title={translate("web.enrollment", "Enrollment") + " - " + auctionData?.name}
                                        btnText={translate(
                                            "web.confirmAndPayNow",
                                            "Confirm & Pay Now"
                                        )}
                                        onSave={() => enrollNow()}
                                        isDisabled={!acceptTerms}

                                    >
                                        <div className="text-start mb-main">
                                            <h4 className="red fw-bold">
                                                {translate("web.auctionFees", "Auction Fees")}:{" "}
                                                {auctionData?.fees} {translate("web.aed", "AED")}
                                            </h4>
                                        </div>

                                        <div className={showIconsContainer}>
                                            {!!userProfile?.fullName &&
                                                <div className={iconContainer}>
                                                    <i className="fa fa-user red"></i>
                                                    <span>{userProfile?.fullName}</span>
                                                </div>
                                            }
                                            <div className={iconContainer}>
                                                <i className="fa fa-sack-dollar red"></i>
                                                <span>{auctionData?.fees} {translate("web.aed", "AED")}</span>
                                            </div>
                                            {!!userProfile?.nationalityName &&
                                                <div className={iconContainer}>
                                                    <i className="fa fa-globe-americas red"></i>
                                                    <span>{userProfile?.nationalityName}</span>
                                                </div>
                                            }
                                            {!!userProfile?.address &&
                                                <div className={iconContainer}>
                                                    <i className="fa-solid fa-location-dot red"></i>
                                                    <span>{userProfile?.address}</span>
                                                </div>
                                            }
                                            {!!userProfile?.phone &&
                                                <div className={iconContainer}>
                                                    <i className="fa-solid fa-phone red"></i>
                                                    <span>{userProfile?.phone}</span>
                                                </div>
                                            }
                                        </div>
                                        <NetaqInput
                                            key={'participateforOthers'}
                                            name='participateforOthers'
                                            type="checkbox"
                                            label={translate(
                                                "web.isBidForOthers",
                                                "Is Bid For Others"
                                            )}
                                            value="accepted"
                                            checked={isBidForOthers}
                                            onChange={(e) => setIsBidForOthers(e.target.checked)}
                                        />
                                        <CustomPopUp
                                            title={translate('web.termsAndConditions', 'TermsAndConditions')}
                                            trigger={
                                                <NetaqInput
                                                    key={'participateforOthers'}
                                                    name='participateforOthers'
                                                    type="checkbox"
                                                    label={translate(
                                                        "web.iAgreeToTheTermsAndConditionsOfTheAuction",
                                                        "I agree to the terms and conditions of the auction"
                                                    )}
                                                    value="accepted"
                                                    checked={acceptTerms}
                                                    onChange={(e) => setAcceptTerms(e.target.checked)}
                                                    isLink
                                                />
                                            }
                                            content={<div
                                                className="text-start"
                                                dangerouslySetInnerHTML={{ __html: currentLanguage == 'en' ? auctionData?.termsAndConditionsTextEn : auctionData?.termsAndConditionsTextAr }}
                                            />}
                                        />
                                    </CustomSecondPopUp>
                                }
                            </div>
                            <div className={showIconsContainer}>
                                {!!auctionData?.horseCount > 0 && (
                                    <div className={iconContainer}>
                                        <i className="fa-solid fa-chess-knight red"></i>
                                        <span>{auctionData?.horseCount} {auctionData?.horseCount > 1 ? <>{translate('web.horses', 'Horses')}</> : <>{translate('web.horse', 'Horse')}</>}</span>
                                    </div>
                                )}
                                <div className={iconContainer} >
                                    <i className="fa fa-gavel red" ></i>
                                    <span>
                                        {auctionData?.type}
                                    </span>
                                </div>
                                {!!auctionData?.auctionFees &&
                                    <div className={iconContainer}>
                                        <i className=" fa-solid fa-sack-dollar C89C66" ></i>
                                        <span>
                                            {auctionData?.auctionFees.toLocaleString('en-US')} {translate("web.aed", "AED")}
                                        </span>
                                    </div>
                                }
                                {!!auctionData?.location &&
                                    <div className={iconContainer}>
                                        <i className=" fa-solid fa-location-dot C89C66"></i>
                                        <span>
                                            <Link
                                                target="_blank"
                                                to={auctionData?.location}
                                                className=" "
                                            >
                                                {translate("web.showonGoogleMaps", "Show on Google Maps")}
                                            </Link>
                                        </span>
                                    </div>
                                }

                                {!!auctionData?.endDate && (
                                    <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                                        {new Date(auctionData?.endDate) > new Date() && (
                                            <AuctionTimer auctionTimer={auctionData?.auctionTimer} startDate={auctionData?.startDate} endDate={auctionData?.endDate} />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row  mb-main rtl">
                            <div className="col-xl-8 col-lg-8 col-md-12 mb-main">
                                <div className={whiteCard}>
                                    <ImagesSlider
                                        sliderName={"bidding"}
                                        data={(!!horseData?.auctionHorseId && horseData?.auctionHorseId != '00000000-0000-0000-0000-000000000000') ? horseData?.horseAttachment : []}
                                        type={"bidding"}
                                        horseName={"myname"}
                                        VideoURL={[auctionData?.liveUrl, auctionData?.introVideoUrl]}
                                    />
                                </div>
                            </div>


                            <div className="col-xl-4 col-lg-4 col-md-12 mb-main">
                                <div className="bg-white p-main border-15 p-3 h-100">
                                    {(!!horseData?.auctionHorseId && horseData?.auctionHorseId != '00000000-0000-0000-0000-000000000000') ?
                                        <>
                                            <div className='mb-form-group'>
                                                <h3 className="bold rtl capatalise">
                                                    {horseData.horseName} {translate("web.lotNo", "Lot No")}.{" "}
                                                    {horseData.lotNumber}
                                                </h3>
                                            </div>
                                            <div className="EventListDivSpacer" />
                                            <label className="bold rtl capatalise">
                                                {translate("web.startPrice", "Start Price")}
                                            </label>
                                            <div className='mb-form-group'>
                                                <i className="fa-solid fa-sack-dollar C89C66"></i>
                                                <span>{horseData?.startingPrice?.toLocaleString("en-US")} {translate("web.aed", "AED")}</span>
                                            </div>
                                            <label className="bold rtl capatalise">
                                                {translate(
                                                    "web.incrementalIncreaseAmount",
                                                    "Incremental Increase Amount"
                                                )}
                                            </label>
                                            <div className='mb-form-group'>
                                                <i className="fa-solid fa-sack-dollar C89C66"></i>
                                                <span>{UIincrementalIncrease?.toLocaleString("en-US")}{" "}
                                                    {translate("web.aed", "AED")}</span>
                                            </div>
                                            <div className='mb-form-group'>
                                                <i className="fa-regular fa-clock C89C66"></i>
                                                <div className='d-inline-block'>
                                                    <CronometerCounter endDate={horseEntryTime} countUp={true} isMinutes={true} />
                                                </div>
                                            </div>
                                        </> :
                                        <div className="">
                                            {translate("web.noHorseInArenaRightNow", "No Horse In Arena Right Now")}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <SectionTitle noMargin section_name={translate("web.auctionBidding", "auction bidding")} />
                        <div className={whiteCard}>
                            <div className="row  rtl">

                                <div className={'col-6 text-end ms-auto'} >
                                    <Link to={`/fullScreenBidding?auctionID=${auctionId}`} title={translate('web.watchInFullScreenMode', 'watch in full screen mode')} target='_blank' className='btn btn-danger text-white' >
                                        <i className=" fa-solid fa-up-right-and-down-left-from-center"></i>
                                    </Link>
                                </div>
                            </div>
                            <div className='row'>

                                {isEnrolledUser && auctionData?.isAuctionLive && auctionData?.isOnlineBiddingEnabled && !!horseData.auctionHorseId && horseData.auctionHorseId != '00000000-0000-0000-0000-000000000000' &&
                                    < div className="col-xl-4 col-lg-3 col-md-12 col-sm-12 mb-main">
                                        <h5 className="fw-bold">
                                            {translate("web.addNewBid", "Add New Bid")}
                                        </h5>
                                        <div className="bg-light border-15 p-3">

                                            <div className="mb-form-group">
                                                <div className="w-50 fw-bold d-inline-block">
                                                    <i className='fa fa-user red' />  {translate("web.bidderNo", "Bidder Nubmer")}

                                                </div>
                                                <div className="w-50 fw-bold text-end d-inline-block    ">
                                                    {bidderNumber}
                                                </div>
                                            </div>
                                            <div className='d-flex flex-wrap rtl mb-form-group'>
                                                {(auctionData?.isAuctionedOneByOne == false) &&
                                                    <div className='col-4 text-start mb-main'>
                                                        <button className='btn btn-secondary' onClick={() => decreaseNewBid()}><i className="fa-solid fa-minus w-unset"></i></button>
                                                    </div>
                                                }
                                                <div className='col-4 text-center red fw-bold mx-auto mb-main'>
                                                    {newBid?.toLocaleString('en-US')} {translate("web.aed", "AED")}
                                                </div>
                                                {(auctionData?.isAuctionedOneByOne == false) &&
                                                    <div className='col-4 text-end mb-main'>
                                                        <button className='btn btn-danger' onClick={() => increaseNewBid()}><i className="fa-solid fa-plus w-unset"></i></button>
                                                    </div>
                                                }
                                                <CustomPopUp
                                                    key={horseData?.lotNumber + " bidd"}
                                                    isBid
                                                    title={translate('web.bid', 'Bid')}
                                                    content={<div className='red fw-bold'>
                                                        {translate(
                                                            "web.youwillbidforanamountof",
                                                            "You will bid for an amount of"
                                                        )}
                                                        {newBid?.toLocaleString('en-US')}  {translate("web.aed", "AED")}
                                                    </div>}
                                                    trigger={<button className='btn btn-danger w-100' >{translate('web.submit', 'Submit')}</button>}
                                                    onClick={() => handleOnsubmit()}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                }

                                {biddersDataLoaded &&
                                    <div className={"col-xl-8 col-lg-9 col-md-12 col-sm-12 rtl mx-auto"}>
                                        <div className="text-center red-f20-pt0">
                                            {translate("web.listOfBids", "List Of Bids")}
                                        </div>
                                        <div className="scrolableTable mx-auto">
                                            <table className="table table-striped table-bordered rtl horseResultTable">
                                                <thead className='theadHorseSelect'>
                                                    <tr>
                                                        <th className='text-center' >{translate("web.bidderNo", "Bidder No")}</th>
                                                        <th className='text-center'  >{translate("web.bidderName", "Bidder Name")}</th>
                                                        <th className='text-center' >{translate("web.bidAmount", "Bid Amount")}</th>
                                                        <th className='text-center'  >{translate("web.bidTime", "Bid Time")}</th>
                                                        <th className='text-center' >{translate("web.bidderType", "Bidder Type")}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {biddersData.map((bidder) => (
                                                        <tr>
                                                            <td className='text-center' style={{ maxWidth: 50 }}>{bidder.bidderNumber}</td>
                                                            <td className='text-center' style={{ maxWidth: 100 }} >
                                                                {bidder.bidderName}
                                                            </td>
                                                            <td className='text-center' style={{ maxWidth: 75 }}>
                                                                {bidder.horseAmount.toLocaleString('en-US')} {translate("web.aed", "AED")}
                                                            </td>
                                                            <td className='text-center' style={{ maxWidth: 100 }}>
                                                                {formateDateToMac(bidder.bidTime)}
                                                            </td>
                                                            <td className='text-center'>
                                                                {bidder.bidderType.toLowerCase() == "live" ||
                                                                    bidder.bidderType.toLowerCase() == "حضوري" ? (
                                                                    <React.Fragment>
                                                                        <i className=" fa-solid fa-circle color-eahsred"></i>{" "}
                                                                        {translate("web.live", "Live")}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    ""
                                                                )}
                                                                {bidder.bidderType.toLowerCase() == "online" ||
                                                                    bidder.bidderType.toLowerCase() == "عبر الانترنت" ? (
                                                                    <React.Fragment>
                                                                        {" "}
                                                                        <i className=" fa-solid fa-circle color-green"></i>{" "}
                                                                        {translate("web.onlineBidder", "Online")}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                </React.Fragment>
                // <></>
            )
            }
        </React.Fragment >
    )
}
